'use strict';
function _typeof(e) {
  return (
    _typeof = 'function' == typeof Symbol &&
    'symbol' == typeof Symbol.iterator ? function (e) {
      return typeof e
    }
     : function (e) {
      return e &&
      'function' == typeof Symbol &&
      e.constructor === Symbol &&
      e !== Symbol.prototype ? 'symbol' : typeof e
    }
  ) (e)
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function')
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable ||
    !1,
    n.configurable = !0,
    'value' in n &&
    (n.writable = !0),
    Object.defineProperty(e, _toPropertyKey(n.key), n)
  }
}
function _createClass(e, t, r) {
  return t &&
  _defineProperties(e.prototype, t),
  r &&
  _defineProperties(e, r),
  Object.defineProperty(e, 'prototype', {
    writable: !1
  }),
  e
}
function _toPropertyKey(e) {
  e = _toPrimitive(e, 'string');
  return 'symbol' == _typeof(e) ? e : String(e)
}
function _toPrimitive(e, t) {
  if ('object' != _typeof(e) || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (void 0 === r) return ('string' === t ? String : Number) (e);
  r = r.call(e, t || 'default');
  if ('object' != _typeof(r)) return r;
  throw new TypeError('@@toPrimitive must return a primitive value.')
}
function _callSuper(e, t, r) {
  return t = _getPrototypeOf(t),
  _possibleConstructorReturn(
    e,
    _isNativeReflectConstruct() ? Reflect.construct(t, r || [], _getPrototypeOf(e).constructor) : t.apply(e, r)
  )
}
function _possibleConstructorReturn(e, t) {
  if (t && ('object' === _typeof(t) || 'function' == typeof t)) return t;
  if (void 0 !== t) throw new TypeError('Derived constructors may only return object or undefined');
  return _assertThisInitialized(e)
}
function _isNativeReflectConstruct() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
    }))
  } catch (e) {
  }
  return (_isNativeReflectConstruct = function () {
    return !!e
  }) ()
}
function _getPrototypeOf(e) {
  return (
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ ||
      Object.getPrototypeOf(e)
    }
  ) (e)
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return e
}
function _inherits(e, t) {
  if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function');
  e.prototype = Object.create(
    t &&
    t.prototype,
    {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }
  ),
  Object.defineProperty(e, 'prototype', {
    writable: !1
  }),
  t &&
  _setPrototypeOf(e, t)
}
function _setPrototypeOf(e, t) {
  return (
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t,
      e
    }
  ) (e, t)
}
function handleSwipe(e, t) {
  var n = t.onSwipeRight,
  o = t.onSwipeLeft,
  i = (
    e.addEventListener(
      'touchstart',
      function (e) {
        i = e.touches[0].clientX,
        l = e.touches[0].clientY
      },
      !1
    ),
    e.addEventListener(
      'touchmove',
      function (e) {
        var t,
        r;
        null !== i &&
        null !== l &&
        (
          t = e.touches[0].clientX,
          r = e.touches[0].clientY,
          t = i - t,
          r = l - r,
          Math.abs(t) > Math.abs(r) &&
          (0 < t ? (e.preventDefault(), o) : (e.preventDefault(), n)) (),
          l = i = null
        )
      },
      !1
    ),
    null
  ),
  l = null
}
customElements.get('product-slider-component') ||
(
  isTouchDevice = 'ontouchstart' in window ||
  0 < navigator.MaxTouchPoints ||
  0 < navigator.msMaxTouchPoints,
  ProductSliderComponent = function () {
    function t() {
      var e;
      return _classCallCheck(this, t),
      (e = _callSuper(this, t))._elImageSlides = null,
      e._elCardSlides = null,
      e.dirty = !1,
      e.element = _assertThisInitialized(e),
      e.elMediaContainer = e.querySelector('.card-product-slider'),//图片集合
      e.isCollectionTemplate = document.querySelector('.template-collection'),
      e.isGrapheneSearchTemplate = document.querySelector('.template-name-search'),
      e.handleSlide(),
      e
    }
    return _inherits(t, SliderComponent),
    _createClass(
      t,
      [
        {
          key: 'elCardSlides',
          get: function () {
            return this._elCardSlides ||
            (
              this._elCardSlides = this.querySelectorAll('.product__media-item')//图片集合的子元素
            ),
            this._elCardSlides
          }
        },
        {
          key: 'handleSlide',
          value: function () {
            var t = this,
            e = this.querySelector('.slider-button--next'),//向右切换的按钮元素
            e = (
              e &&
              e.addEventListener(
                'click',
                function (e) {
                  e.preventDefault(),
                  t.dirty = !0,
                  plusSlides(t, 1)
                }
              ),   
              e.addEventListener(
                'keydown',
                function (e) {
                  if (e.key === 'Enter' || e.key==' ') {
                  e.preventDefault(),
                  t.dirty = !0,
                  plusSlides(t, 1)
                  }
                }
              ),            
              this.querySelector('.slider-button--prev')//向左切换的按钮元素
            ),
            e = (
              e &&
              e.addEventListener(
                'click',
                function (e) {
                  e.preventDefault(),
                  t.dirty = !0,
                  plusSlides(t, - 1)
                }
              ),
              e.addEventListener(
                'keydown',
                function (e) {
                  if (e.key === 'Enter' || e.key==' ') {
                    e.preventDefault(),
                    t.dirty = !0,
                    plusSlides(t, - 1)
                  }
                }
              ),  
              this.querySelector('.card-product-slider')
            ),
            r = this.closest('.card__media');
            e &&
            1 < this.elCardSlides.length &&
            (
              null == this.isCollectionTemplate &&
              null == this.isGrapheneSearchTemplate ||
              handleSwipe(
                e,
                {
                  onSwipeRight: function () {
                    return plusSlides(t, - 1)
                  },
                  onSwipeLeft: function () {
                    return plusSlides(t, 1)
                  }
                }
              ),
              r.addEventListener(
                'mouseenter',
                function (e) {
                  t.dirty ||
                  isTouchDevice ||
                  plusSlides(t, 1)
                }
              ),
              r.addEventListener(
                'mouseleave',
                function (e) {
                  t.dirty ||
                  isTouchDevice ||
                  plusSlides(t, - 1)
                }
              )
            )
          }
        }
      ]
    ),
    t
  }(),
  customElements.define('product-slider-component', ProductSliderComponent)
);
var isTouchDevice,
ProductSliderComponent,
slideIndexNumber = 1;
function plusSlides(e, t) {
  var e = e.closest('product-slider-component'),
  r = e.querySelectorAll('.slider-pagination .dot'),
  r = Array.from(r).findIndex(function (e) {
    return e.classList.contains('is-active')
  }) + 1 + t,
  n = e.elCardSlides.length;
  n < r ? r = 1 : r < 1 &&
  (r = n),
  showSlides(r, e, Math.sign(t))
}
function currentSlide(e, t) {
   e = e.parentElement.parentElement;
  showSlides(slideIndexNumber = t, e, 1)
}
function showSlides(e, t, r) {
  var n,
  o = (t = t.closest('product-slider-component')).elCardSlides,
  i = t.querySelectorAll('.slider-pagination .dot');
  for (
    e > o.length &&
    (slideIndexNumber = 1),
    e < 1 &&
    (slideIndexNumber = o.length),
    n = 0;
    n < o.length;
    n++
  ) o[n].classList.remove('is-active');
  for (n = 0; n < i.length; n++) i[n].className = i[n].className.replace(' is-active', '');
  var t = o[e - 1],
  l = 1 == r ? o[e % o.length] : o[e - 2 < 0 ? o.length - 1 : e - 2];
  l.querySelector('.lazyload') &&
  t.querySelector('img').addEventListener(
    'load',
    function () {
      l.querySelector('.lazyload').classList.add('lazypreload')
    },
    {
      once: !0
    }
  ),
  null != (r = t.querySelector('.lazyload')) &&
  r.setAttribute('fetchpriority', 'high'),
  t.classList.add('is-active'),
  i[e - 1].className += ' is-active'
}

class ColorChangeComponent extends HTMLElement {
  constructor() {
    super();
    const swatchContainer = this.querySelector("fieldset");
    const hidecountbtn = this.querySelector(".over-swatch-btn");
    var countnum = hidecountbtn.querySelector(".more-swatch")
    const swathitem = this.querySelectorAll('.s-item');
    const swatchinput = this.querySelectorAll('.swatch-input__input');
    const swatchbtn = this.querySelectorAll('.swatch');
     var backtoleft = this.querySelector('.backtoleft');
    for (const swinput of swatchinput) {
      swinput.addEventListener('click', this.onClicktoCoverImage2.bind(this));
    }
    for (const swatch of swatchbtn) {
      swatch.addEventListener('click', this.onClicktoCoverImage.bind(this));
      swatch.addEventListener('mouseenter', this.onHovertoCoverImage.bind(this)); 
      swatch.addEventListener('keydown', this.onkeydownSwatch.bind(this)); 
    }
  hidecountbtn.addEventListener('click', this.onShowMoreColor.bind(this));
    if(backtoleft)backtoleft.addEventListener('click', this.onshowOriginColor.bind(this))
    
   
      function debounce(func, delay) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }
    
    const resizeObserver = new ResizeObserver(debounce(() => {
      setTimeout(() => {
          const containerWidth = swatchContainer.clientWidth;
            if(containerWidth!= 0){
                this.init(swatchContainer,swathitem,hidecountbtn,countnum);
            }else{
              setTimeout(() => { this.init(swatchContainer,swathitem,hidecountbtn,countnum);},200)
            }
      }, 200);

      },200));

      resizeObserver.observe(swatchContainer);
    }

  init(swatchContainer,swathitem,hidecountbtn,countnum){
    const containerWidth = swatchContainer.clientWidth;
    const swatchWidth = Array.from(swathitem).reduce((total, swatch) => {
      return total + swatch.offsetWidth + 4 ;
  }, 0);
  
  if (swatchWidth > containerWidth) {
  let hidedefaultshownum = this.calculateSwatches(containerWidth,swathitem[0].offsetWidth+4);
  let showcolorcount = swathitem.length - hidedefaultshownum;
  // console.log("hidecolorcount:"+  showcolorcount);
  // console.log("hidedefaultshownum:"+  hidedefaultshownum);
  // console.log("lenght:"+  swathitem.length);
  swatchContainer.style.width = containerWidth;
  hidecountbtn.classList.remove('hidden');
  countnum.textContent ='+'+showcolorcount;
  countnum.setAttribute("more-swatch-count",hidedefaultshownum);
  countnum.setAttribute("hide-swatch-count",showcolorcount);
  
  swathitem.forEach((item, index) => {
    if (index >= hidedefaultshownum) {
    item.classList.add('d-none');
   }
  });

  } 
  }

  onshowOriginColor(event){
    const elElement = event.currentTarget;
    const elPrent = elElement.closest(".item-swatch");
    let hidecountbtn = elPrent.querySelector(".over-swatch-btn");
    elElement.classList.add("d-none");
    hidecountbtn.classList.remove('d-none');
    elPrent.style.left= `0` ;
    var hideitem = elPrent.querySelectorAll(".s-item.d-block");
    for (const item of hideitem) {
      item.classList.remove('d-block');
    }    
  }
   calculateSwatches(containerWidth,swatchWidth) {
    let containerUseWidth = containerWidth -  swatchWidth;
    const count = Math.floor(containerUseWidth / swatchWidth); // 计算能放多少个色块
    return count;
}

  onShowMoreColor(event){
    const elElement = event.currentTarget;
    const elPrent = elElement.closest(".item-swatch");
    const index = elElement.querySelector(".more-swatch").getAttribute("more-swatch-count") ; 
    const elPrent_toLeft = Number(index*34);
    let backleftbtn =  elPrent.querySelector(".backtoleft");
    if(backleftbtn)
      var newLi = backleftbtn;
    else{
      var newLi = document.createElement('li');
          newLi.className = 'backtoleft';
          newLi.innerHTML = `<label>
              <svg aria-hidden="true" role="img" aria-labelledby="backleft-${index}" tabindex="0" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: none;">
                  <title id="backleft-${index}">button to view more</title>
                  <path d="M0.999541 1.40417L5.11719 5.52182L0.99954 9.63947" stroke="#B4B4B4" stroke-width="1.23529"></path>
              </svg>
              <span class="sr-only">Back to view left colors</span>
              </label>
          `;
          }
      const targetLI = elPrent.querySelector(`li:nth-child(${index})`);

      targetLI.parentNode.insertBefore(newLi, targetLI.nextSibling);

    let hideitem = elElement.closest(".item-swatch").querySelectorAll(".s-item.d-none");
    for (const item of hideitem) {
     item.classList.add('d-block');
    }
  elElement.classList.add('d-none');
  newLi.classList.remove('d-none');
  elPrent.style.left= `-${elPrent_toLeft}px` ;

  newLi.addEventListener('click', (event) => {
    this.onshowOriginColor(event);
});

  }
  onClicktoCoverImage2(event) {
    const elElement = event.currentTarget;
    const labelElement = elElement.nextElementSibling;
    if (labelElement) {
      const swatchElement = labelElement.querySelector('.swatch');
      swatchElement.click();
    }
  }
  onClicktoCoverImage(event) {
    const elElement = event.currentTarget;
    const imgSrc = elElement.getAttribute('data-img');
    const parentWrapper = elElement.closest('.card-wrapper');
    const target_img = parentWrapper.querySelector('.first-img img');
    const target_img_src= target_img.getAttribute("src");

    elElement.setAttribute("tabindex",0);
    if (target_img_src != imgSrc ) {
      target_img.setAttribute('src', imgSrc);
      target_img.setAttribute('srcset', imgSrc);
        console.log('Updated img src to:', imgSrc);
    } else {
        console.log('No img element found.');
    }

    const parentLi = elElement.closest('.item-swatch');
    const siblings = parentLi.querySelectorAll('.swatch');
    for (const sibling of siblings) {
        if (sibling !== elElement) {
            sibling.setAttribute('tabindex', '-1');
        }
    }
  }
  onHovertoCoverImage(event){
    const elElement = event.currentTarget;

    if(event.type=='mouseenter') {
      elElement.click();
    }
  }

  onkeydownSwatch(event){
              const elElement = event.currentTarget;
              const index = parseInt(elElement.getAttribute("data-valueindex"));
              const totalSize = parseInt(elElement.closest(".item-swatch").getAttribute("data-count"));
              let nextIndex = index + 1;
              let prevIndex = index - 1;
              
              // 循环处理
              if (nextIndex > totalSize) {
                  nextIndex = 1;
              }
              if (prevIndex <= 0) {
                  prevIndex = totalSize;
              }
  
              // 处理键盘事件
              if (event.key === 'Enter' || event.key==' ') {
                  this.click();
              }
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                  const nextLabel = elElement.closest(".item-swatch").querySelector(`.swatch[data-valueindex='${nextIndex}']`);
                  if (nextLabel) {                   
                      nextLabel.focus();
                      nextLabel.click();
                      nextLabel.addEventListener('click', this.onClicktoCoverImage.bind(this));
                      
                      // nextLabel.dispatchEvent(new MouseEvent('mouseover')); // 触发 mouseover 事件
                      
                  }
              }
              if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                  const prevLabel = elElement.closest(".item-swatch").querySelector(`.swatch[data-valueindex='${prevIndex}']`);
                  if (prevLabel) {                   
                      prevLabel.focus();
                       prevLabel.click();
                      // prevLabel.dispatchEvent(new MouseEvent('mouseover')); // 触发 mouseover 事件
                      prevLabel.addEventListener('click', this.onClicktoCoverImage.bind(this));
                  }
              }

  }

}
customElements.define('color-change-component', ColorChangeComponent);